/**
 * @file Patient API helpers.
 */

import { getNextCaseFileNumberCallable } from "../../app/firebase/callables.js";

/**
 * Gets the next available patient case file number preview.
 * @returns {Promise<string|null>} Next case file number or null on failure.
 */
export async function getNextCaseFileNumber() {
    try {
        const result = await getNextCaseFileNumberCallable({});
        return result.data.code;
    } catch (error) {
        console.error("Error fetching case file number:", error);
        return null;
    }
}
